import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import authService from "@services/auth";
import routes from "@router/routes";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page"
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/Login",
    "/login",
    "/Logout",
    "/logout",
    "/CadastrarSenha",
    "/EsqueceuSenha"
  ];
  const authRequired = !publicPages.includes(to.path);
  const requiredRoles = to.meta?.requiredRoles;
  if (authRequired) {
    var authenticated = authService.isAuthenticated();

    // refreshtoken
    if (authenticated === false) {
      const isAuthenticated = () => {
        authService.refreshToken().then(() => authService.isAuthenticated());
      };
      authenticated = isAuthenticated();
    }

    if (authenticated === true) {
      if (requiredRoles != null && !authService.hasRole(requiredRoles())) {
        return next("/403");
      }
    } else {
      return next("/Login");
    }
  }

  const windowRedirectAfter = from.meta?.windowRedirectAfter;

  if (windowRedirectAfter === true) {
    window.location.href = to.fullPath;
    return;
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  next();
});

export default router;
